// extracted by mini-css-extract-plugin
export default {"populares":"Populares_populares__CX-ES","populares__imagens":"Populares_populares__imagens__VQvPY"};